import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import FundingSheet, { OperationsFundingSheet } from './Admin/FundingSheet';

const PublicFundingSheet = () => {
  // Check URL params for initial tab
  const urlParams = new URLSearchParams(window.location.search);
  const view = urlParams.get('view');
  const initialTab = view === 'operations' ? 1 : 0;
  
  const [selectedTab, setSelectedTab] = useState(initialTab);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Update URL to reflect current view
    const newView = newValue === 1 ? 'operations' : 'full';
    const url = new URL(window.location);
    url.searchParams.set('view', newView);
    window.history.replaceState({}, '', url);
  };

  return (
    <Box sx={{ width: '100%', backgroundColor: 'var(--background-color, #0A0A0A)', minHeight: '100vh' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: 'var(--background-color, #1a1a1a)' }}>
        <Tabs 
          value={selectedTab} 
          onChange={handleTabChange} 
          sx={{
            '& .MuiTab-root': {
              color: '#888',
              fontWeight: 600,
              fontSize: '16px',
              textTransform: 'none',
              '&.Mui-selected': {
                color: 'var(--text-primary, #fff)',
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#4CAF50',
            },
            paddingLeft: '20px',
          }}
        >
          <Tab label="Full Funding Sheet ($5M Total Budget)" />
          <Tab label="Operations Only ($2.5M Operations Budget)" />
        </Tabs>
      </Box>
      
      <Box sx={{ p: 0 }}>
        {selectedTab === 0 && (
          <div>
            <FundingSheet user={null} isPublic={true} />
          </div>
        )}
        {selectedTab === 1 && (
          <div>
            <OperationsFundingSheet user={null} isPublic={true} />
          </div>
        )}
      </Box>
    </Box>
  );
};

export default PublicFundingSheet;